// connect with rapid.api
///'"/\)(*&%$#@!}{<>][:"
export const exerciseOptions = {
  method: 'GET',
  url: 'https://exercisedb.p.rapidapi.com/exercises/',
  params: {
    offset: '0'
  },
  headers: {
    'x-rapidapi-key': process.env.REACT_APP_RAPID_API_KEY,
    'x-rapidapi-host': 'exercisedb.p.rapidapi.com'
  }
};

export const youtubeOptions = {
  method: 'GET',
  headers: {
    'X-RapidAPI-Host': 'youtube-search-and-download.p.rapidapi.com',
    'X-RapidAPI-Key': process.env.REACT_APP_RAPID_API_KEY,
  },
};

// export const fetchData = async (url, options) => {
//   const res = await fetch(url, options);
//   const data = await res.json();
//   return data;
// };
export const fetchData = async (url, options, params = {}) => {
  const query = new URLSearchParams(params).toString();
  const res = await fetch(`${url}?${query}`, options);
  const data = await res.json();
  return data;
};

export const foodOptions = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
};

export const foodBarCode = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
};